import { Button } from '@/ui/design-system/components/ui/button';
import { mixpanelTrack } from 'utils/app/configureMixpanel';
import { useAssistantContext } from './AssistantProvider';

// Names no subject on purpose: every successful get_entity_data call in the
// chat is harvested into the report, so a report "about retinol" would still
// carry whatever else the conversation touched.
//
// `prompt` is what system.md keys the conversion rules on — the ones that stop
// the model re-running data the chat already holds — so don't reword it.
const REPORT_FOLLOW_UP_ID = 'make_report';
export const REPORT_FOLLOW_UP = {
    id: REPORT_FOLLOW_UP_ID,
    label: 'Create a report',
    prompt: 'Turn this chat into a report',
};

const FollowUps = ({ entries }) => {
    const { sendMessage } = useAssistantContext();

    if (!entries || entries.length === 0) return null;

    const handleClick = (entry) => {
        mixpanelTrack('AI Assistant Follow-up Clicked', {
            follow_up_id: entry.id,
            label: entry.label,
        });
        sendMessage(entry.prompt, {
            is_followup: true,
            follow_up_id: entry.id,
        });
    };

    const hasDrillDowns = entries.some(
        (entry) => entry.id !== REPORT_FOLLOW_UP_ID,
    );

    return (
        <div className="flex flex-col gap-2">
            {hasDrillDowns && (
                <span className="text-xs font-semibold text-muted-foreground">
                    Keep exploring
                </span>
            )}
            <div className="flex flex-wrap gap-2">
                {entries.map((entry) => (
                    // min-w-0 is what lets the button shrink below its
                    // content; truncate's overflow does it for the label.
                    <Button
                        key={entry.id}
                        variant="outline"
                        size="sm"
                        onClick={() => handleClick(entry)}
                        title={entry.label}
                        className="min-w-0 max-w-full"
                    >
                        <span className="truncate">{entry.label}</span>
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default FollowUps;
